import { render, staticRenderFns } from "./ZddDetail.vue?vue&type=template&id=63e6ec84&scoped=true"
import script from "./ZddDetail.vue?vue&type=script&lang=js"
export * from "./ZddDetail.vue?vue&type=script&lang=js"
import style0 from "./ZddDetail.vue?vue&type=style&index=0&id=63e6ec84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e6ec84",
  null
  
)

export default component.exports